import styled from 'styled-components'

export const Container = styled.div `
  position: absolute;
  display: flex;
  align-items: center;
  height: 48px;
  bottom: 15px;
  left: 15px;
  color: #FFF;

  @media (min-width: 768px) {
    left: 80px;
    bottom: 20px;
  }
`

export const BtnClose = styled.div`
  position: absolute;
  width: 36px;
  height: 36px;
  top: calc(140px - 100vh);
  cursor: pointer;
`

export const BtnPlayPauseContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 29px;
  border: solid 1px transparent;

  &.bordered {
    border: solid 1px #FFF;
  }

  cursor: pointer;

  .btn-play {
    margin-left: 4px;
    transition: all .2s ease-in-out;
  }

  .btn-pause {
    transition: all .2s ease-in-out;
  }

  &:hover {
    .act-hover {
      transform: translate(-50%, -50%) scale(4);
      border-radius: 8px;
      stroke-width: 4px;
    }

    .btn-play, .btn-pause {
      color: #FFF;
    }
  }

  .act-hover {
    position: absolute;
    top: 50%;
    left: 50%;
    transform-origin: center;
    transform: translate(-50%, -50%) scale(16);
    transition: all .3s ease-in-out;
    z-index: -1;
    stroke-width: 0px;
    color: #000;
    stroke: #000;
    opacity: .65;
  }
`

export const ContainerHover = styled.div`
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 29px;
  cursor: pointer;
  overflow: hidden;
`

export const ContainerProgressBar = styled.div`
  position: absolute;
  width: 48px;
  height: 48px;
  z-index: 2;
  pointer-events: none;
`

export const DescriptionContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 200px;
  height: 30px;
  overflow: hidden;
  margin-left: 20px;
`

export const TextDescription = styled.p`
  color: #FFF;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.8px;
  margin: 0;
  padding: 0;
  opacity: 1;
  transform: translateX(0);
  transition: all .35s ease-in-out;

  @media (min-width: 768px) {
    transform: translateX(0);

    &.hover {
      transform: translateX(-100px);
      opacity: 0;
    }
  }
`

export const MenuLanguageContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  top: -50%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 64px;
  height: 50px;
  opacity: 0;
  transition: all .2s ease-out;

  &.hover {
    opacity: 1;
    transform: translate(-50%, -30%);
  }
`